var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._t("default"),_vm._v(" "),_c('transition',{attrs:{"name":"component-fade"}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.loadingText))])]):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }